import { useEffect, useRef, useCallback } from 'react'
import { Html5Qrcode } from 'html5-qrcode'

interface QRScannerProps {
  onScan: (value: string) => void
  onError?: (err: string) => void
  active: boolean
}

export function QRScanner({ onScan, onError, active }: QRScannerProps) {
  const ref = useRef<HTMLDivElement>(null)
  const scannerRef = useRef<Html5Qrcode | null>(null)

  const handleScan = useCallback(
    (decodedText: string) => {
      onScan(decodedText)
    },
    [onScan]
  )

  useEffect(() => {
    if (!active || !ref.current) return
    const start = async () => {
      try {
        const scanner = new Html5Qrcode('qr-reader')
        await scanner.start(
          { facingMode: 'environment' },
          { fps: 10, qrbox: { width: 220, height: 220 } },
          handleScan,
          (msg) => onError?.(msg)
        )
        scannerRef.current = scanner
      } catch (e) {
        onError?.(e instanceof Error ? e.message : 'Camera error')
      }
    }
    start()
    return () => {
      scannerRef.current?.stop().catch(() => {})
      scannerRef.current = null
    }
  }, [active, handleScan, onError])

  if (!active) return null
  return (
    <div ref={ref} className="qr-scanner-wrap">
      <div id="qr-reader" style={{ width: '100%', maxWidth: 400 }} />
    </div>
  )
}
